module.exports = __webpack_public_path__ + "static/media/logo.b5d7fa35.svg";